import useReveal from "../hooks/useReveal";
import Navbar from "../components/Navbar/Navbar";
import Newsletter from "../components/Newsletter/Newsletter";
import Footer from "../components/Footer/Footer";
import "./AboutUs.css";

export default function AboutUs() {
  useReveal();

  return (
    <>
      <Navbar />

      {/* Hero Section */}
      <section className="about-hero">
        <div className="about-hero-content">
          <div className="about-hero-text reveal">
            <h1>
              Building Games & Digital
              <br />
              Experiences That Matter
            </h1>

            <p>
              We create engaging, high-performance games and digital products
              that players love. From concept to launch, our expert team
              delivers scalable, innovative solutions trusted by clients
              worldwide.
            </p>

            <a href="#why-work" className="btn-primary">
              Learn more
            </a>
          </div>

          <div className="about-hero-image reveal">
            <img
              src="/x.png"
              alt="Building Games and Digital Experiences"
              className="about-hero-image-img"
            />
          </div>
        </div>
      </section>

      {/* Why Work With Us */}
      <section className="why-work-section section" id="why-work">
        <div className="container">
          <div className="why-work-header reveal">
            <h2 className="section-title">Why work with us</h2>

            <p className="section-desc">
              We build scalable, high-quality games tailored for multiple
              platforms and player experiences.
            </p>
          </div>

          <div className="why-work-grid">
            <div
              className="why-work-card reveal"
              style={{ transitionDelay: "0s" }}
            >
              <h3>Expertise Across Platforms</h3>

              <p>
                Our team has deep experience developing games for mobile, PC,
                console, and emerging platforms like VR/AR. We understand the
                unique challenges of each ecosystem.
              </p>
            </div>

            <div
              className="why-work-card reveal"
              style={{ transitionDelay: "0.1s" }}
            >
              <h3>Player-Centric Design</h3>

              <p>
                Every decision we make is guided by player needs. We use
                data-driven insights and playtesting to create experiences
                that truly resonate with your audience.
              </p>
            </div>

            <div
              className="why-work-card reveal"
              style={{ transitionDelay: "0.2s" }}
            >
              <h3>Scalable Technology</h3>

              <p>
                We build robust, future-proof architectures that can grow with
                your player base. Our solutions are optimized for performance,
                security, and long-term maintainability.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Who We Are */}
      <section className="why-we-are-section">
        <div className="why-we-are-content">
          <div className="why-we-are-image reveal">
            <img
              src="/RG2.jpg"
              alt="Who We Are"
              className="why-we-are-image-img"
              loading="lazy"
            />
          </div>

          <div className="why-we-are-text reveal">
            <h2>Who We Are</h2>

            <p>
              iGamesTech is a passionate team of game developers, designers,
              and engineers dedicated to creating unforgettable digital
              experiences. Founded with a vision to push the boundaries of
              interactive entertainment, we combine technical excellence with
              creative storytelling.
            </p>

            <p>
              Our diverse portfolio spans mobile games, PC titles, and
              cross-platform experiences. We partner with studios of all
              sizes—from indie developers to major publishers—to bring their
              visions to life.
            </p>
          </div>
        </div>
      </section>

      {/* Our Team */}
      <section className="team-section section">
        <div className="container">
          <div className="team-header reveal">
            <h2 className="section-title">Our Team</h2>

            <p className="section-desc">
              Meet the experts behind iGamesTech's success.
            </p>
          </div>

          <div className="team-grid">
            {[
              {
                name: "Chetan Rathi",
                role: "CEO & Co-Founder, iGamesTech",
                photo: "/chetan-rathi.jpg",
                quote:
                  "At iGamesTech, our vision is to build innovative digital products that combine technology, creativity, and intelligent solutions. As CEO & Co-Founder, my focus is on building a strong team, creating scalable products, and taking iGamesTech toward long-term growth in the global technology industry.",
              },
             
            ].map((member, i) => (
              <div
                className="team-card reveal"
                key={i}
                style={{ transitionDelay: `${i * 0.08}s` }}
              >
                {member.photo ? (
                  <div className="team-avatar team-avatar-photo">
                    <img src={member.photo} alt={member.name} />
                  </div>
                ) : (
                  <div className="team-avatar">👤</div>
                )}

                <h4>{member.name}</h4>

                <p>{member.role}</p>

                <p className="team-quote">"{member.quote}"</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Why Choose iGamesTech */}
      <section className="why-choose-about section">
        <div className="container">
          <div className="reveal">
            <h2 className="section-title">Why Choose iGamesTech</h2>

            <p
              className="section-desc"
              style={{ maxWidth: "100%" }}
            >
              With years of experience in game and app development, our expert
              team delivers scalable, secure, and visually engaging solutions
              trusted by clients worldwide.
            </p>
          </div>
        </div>
      </section>

      <Newsletter />
      <Footer />
    </>
  );
}
